<div class="ds-progress-bar" [class.is-compact]="compact">
  <div class="ds-progress-bar__fill" [style.width.%]="clampedPercent"></div>
</div>
